import React, { PureComponent } from "react";
import styled from "styled-components";
import { cssMainSelector } from "../lib/cssSelectors";
import { CSS_CLASS_PREFIX } from "../constants/css";
import MaterialIconsRegularEot from "../fonts/materialIcons/MaterialIcons-Regular.eot";
import MaterialIconsRegularTtf from "../fonts/materialIcons/MaterialIcons-Regular.ttf";
import MaterialIconsRegularWoff from "../fonts/materialIcons/MaterialIcons-Regular.woff";
import MaterialIconsRegularWoff2 from "../fonts/materialIcons/MaterialIcons-Regular.woff2";

const Container = styled.span`
  ${p => cssMainSelector(p.theme.tdsId)} {
    @font-face {
      font-family: "Material Icons";
      font-style: normal;
      font-weight: 400;
      src: url(${MaterialIconsRegularEot});
      src: local("Material Icons"), local("MaterialIcons-Regular"),
        url(${MaterialIconsRegularWoff2}) format("woff2"),
        url(${MaterialIconsRegularWoff}) format("woff"),
        url(${MaterialIconsRegularTtf}) format("truetype");
    }

    .${CSS_CLASS_PREFIX}-material-icon {
      font-family: "Material Icons";
      font-weight: normal;
      font-style: normal;
      font-size: ${p => p.theme.font.size};
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;

      /* Support for all WebKit browsers. */
      -webkit-font-smoothing: antialiased;
      /* Support for Safari and Chrome. */
      text-rendering: optimizeLegibility;

      /* Support for Firefox. */
      -moz-osx-font-smoothing: grayscale;

      /* Support for IE. */
      font-feature-settings: "liga";

      vertical-align: -2px;
    }
  }
`;

class MaterialIcon extends PureComponent {
  render() {
    const { children } = this.props;

    return (
      <Container>
        <i className={`${CSS_CLASS_PREFIX}-material-icon`}>{children}</i>
      </Container>
    );
  }
}

export default MaterialIcon;
